// ============================================
// ChatContainer Component
// Main container for chat UI (sidebar + floating windows)
// ============================================

import React from 'react';
import { ChatSidebar } from './ChatSidebar';
import { ChatWindow } from './ChatWindow';
import { AnonymousChatWindow } from './AnonymousChatWindow';
import { useChatContext } from '@/context/ChatContext';
// Removed floating chat button imports (no longer used)
import { cn } from '@/lib/utils';
import { useSession } from '@/context/SessionContext';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export const ChatContainer: React.FC = () => {
  const { openWindows, sidebarOpen, toggleSidebar, unreadCount } = useChatContext();
  const { session } = useSession();

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024;
  const hasMaximizedWindows = openWindows.some(w => !w.isMinimized);
  const hasMinimizedWindows = openWindows.some(w => w.isMinimized);

  // Calculate button position
  let buttonPosition = 'bottom-4';
  if (hasMaximizedWindows) {
    buttonPosition = 'max-md:bottom-[calc(45vh+1rem)] md:bottom-4';
  } else if (hasMinimizedWindows) {
    buttonPosition = 'max-md:bottom-[4.5rem] md:bottom-4';
  }

  return (
    <TooltipProvider>
      <>
        {/* Floating chat toggle removed per request */}

      {/* Chat sidebar */}
      <ChatSidebar />

      {/* Floating chat windows */}
      {openWindows.map((window, index) => (
        // Anonymous visitor window only when there is no authenticated user.
        // If authenticated staff opens an anonymous support thread, route to ChatWindow,
        // which internally renders StaffAnonymousChatWindow.
        window.isAnonymous && !session?.user ? (
          <AnonymousChatWindow
            key={`${window.id}-${window.isMinimized ? 'min' : 'max'}`}
            window={window}
            index={index}
          />
        ) : (
          <ChatWindow
            key={`${window.id}-${window.isMinimized ? 'min' : 'max'}`}
            window={window}
            index={index}
          />
        )
      ))}
      </>
    </TooltipProvider>
  );
};
